import React from "react"
import { useLocation } from "react-router"
import { Location } from "history"
import { checkPath } from "../../../utils/validation-utils"

interface Props {
  text?: string
  href: string
}

const TextLink: React.FC<Props> = ({ text }) => {
  const location = useLocation<Location>()
  const { pathname } = location
  const { search } = useLocation()

  const removeReg = () => localStorage.removeItem("Reg Number")
  return (
    <>
      {pathname !== "/valuation-given/" && (
        <div className="tag-container">
          <a
            href={`${process.env.PUBLIC_URL}${checkPath(search)}`}
            className="change-vehicle-tag"
            onClick={removeReg}
          >
            {text}
          </a>
        </div>
      )}
    </>
  )
}

export { TextLink }
